// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"FocalItemsSlice_tabContainer__q8u8U"};